import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import '../../Typography/src/Heading.js';
import { Link } from '../../Typography/src/Link.js';
import '../../Typography/src/ListItem.js';
import '../../Typography/src/OrderedList.js';
import '../../Typography/src/Text.js';
import '../../Typography/src/UnorderedList.js';
import modules_3fa78883 from '../styles/Breadcrumb.module.less.js';

/**
 * @description Breadcrumb Item component.
 *
 * @component
 * @example
 * ```jsx
 * <Breadcrumb.Item>Home</Breadcrumb.Item>
 * ```
 */
const Item = React.forwardRef((props, ref) => {
    const { className, children, ...restProps } = props;
    const cx = useStyles(modules_3fa78883);
    return (React.createElement(Link, { ref: ref, className: cx(className, 'item'), ...restProps, color: "dark" }, children));
});
Item.defaultProps = {};
Item.displayName = 'Item';

export { Item };
//# sourceMappingURL=BreadcrumbItem.js.map
